import i18n from 'i18next'
import config from './config'
import LanguageDetector from 'i18next-browser-languagedetector'
import {initReactI18next} from 'react-i18next'
import Backend from 'i18next-http-backend';

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(Backend)
    .init({
        backend: {
            loadPath: `https://service-generator.s3.amazonaws.com/${config.website.tradEnv}/website/${config.website.nameTemplate}.json`,
            parse: (data) => {
                const deepContent = JSON.parse(data).content.reduce((content, element) => {
                    if(!element.key) return content;
                    const keyArray = element.key.split('.');
                    keyArray.reduce((content, value, index) => {
                        if (!content) content = {};
                        if (typeof content !== 'object') return content;
                        if (index + 1 !== keyArray.length && !content[value]) content[value] = {};
                        if (index + 1 === keyArray.length) content[value] = element.value;
                        return content[value]
                    }, content)
                    return content;
                }, {})
                return deepContent
            }
        },
        react: {
            useSuspense: false
        },
        supportedLngs: ['en', 'fr', 'es'],
        fallbackLng: ['en'],
        detection: {
            order: ['cookie', 'navigator'],
            lookupCookie: 'i18nextLng',
            caches: ['cookie'],
            cookieOptions: { path: '/', sameSite: 'strict' },
            checkWhitelist: true
        }
    })

export default i18n